module.exports = __webpack_public_path__ + "logo.02366620.png";